import React, { useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaChartPie, FaClock, FaPlusCircle, FaMoneyBill, FaTasks, FaRegFilePdf, FaUserSlash } from "react-icons/fa";
import { MdPeople, MdCheckCircle, MdInventory, MdAttachMoney, MdOutlineManageSearch } from "react-icons/md";
import { IoMdSettings } from "react-icons/io";
import { GiMoneyStack } from "react-icons/gi";

import { GlobalContext } from "../Context/GlobalState";
import { BASE_URL_API_TRANXT_UAT_API } from "../utils/Constant";
const iconMap = {
  "HR Dashboard": <FaChartPie style={{ color: "Plum" }} />,
  "Employee Management": <MdPeople style={{ color: "#FFC300" }} />,
  "Salary Management": <FaChartPie style={{ color: "Plum" }} />,
  "Attendance Management": <FaClock style={{ color: "Turquoise" }} />,
  "Office Inventory": <MdInventory style={{ color: "#41B06E" }} />,
  "Leave Management": <MdOutlineManageSearch style={{ color: "yellow" }} />,
  "Leave Approval": <MdCheckCircle style={{ color: "pink" }} />,
  "Add Leave/WFH": <MdCheckCircle style={{ color: "#DAF7A6" }} />,
  "Expense Management": <FaMoneyBill style={{ color: "Plum" }} />,
  "Payroll Management": <MdAttachMoney style={{ color: "yellow" }} />,
  "Expense Payroll": <FaPlusCircle style={{ color: "orange" }} />,
  "Task Overview": <FaTasks style={{ color: "pink" }} />,
  "Contract": <MdAttachMoney style={{ color: "green" }} />,
  "Arrear": <GiMoneyStack style={{ color: "green" }} />,
  "Account Ledger": <MdAttachMoney style={{ color: "yellow" }} />,
  "Policy": <FaRegFilePdf style={{ color: "red" }} />,
  "Inactive Employee": <FaUserSlash style={{ color: "#96C9F4" }} />,
  "Settings": <IoMdSettings style={{ color: "yellow" }} />,
};

const hrLinks = [
    { to: "/Hr/HRDashboard", name: "HR Dashboard" },
  { to: "/Hr/EmployeeManagement", name: "Employee Management" },
  { to: "/Hr/SalaryManagement", name: "Salary Management" },
  { to: "/Hr/AttendanceManagement", name: "Attendance Management" },
  { to: "/Hr/OfficeInventory", name: "Office Inventory" },
  { to: "/Hr/LeaveManagement", name: "Leave Management" },
  { to: "/Hr/LeaveApproval", name: "Leave Approval" },
  { to: "/Hr/AddLeaveWFH", name: "Add Leave/WFH" },
  { to: "/Hr/ExpenseManagement", name: "Expense Management" },
  { to: "/Hr/PayrollManagement", name: "Payroll Management" },
  { to: "/Hr/ExpensePayroll", name: "Expense Payroll" },
  { to: "/Hr/task-overview", name: "Task Overview" },
  { to: "/Hr/Contract", name: "Contract" },
  { to: "/Hr/GenerateArrear", name: "Arrear" },
  { to: "/Hr/AccountLedger", name: "Account Ledger" },
  { to: "/Hr/policy", name: "Policy" },
  { to: "/Hr/inactive-employee", name: "Inactive Employee" },
  { to: "/Hr/Hr-settings", name: "Settings" },
];

const HrSidebar = () => {
  const { pathname } = useLocation();
  const { user, accessData, setAccessData } = useContext(GlobalContext);

  const fetchAccessData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetAccessManagementSuperAdmin`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ firmid: user.firm_id, empid: user.userid }),
        }
      );
      const data = await res.json();
      if (data.status === "0") setAccessData(data.data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (user?.firm_id && user?.userid) fetchAccessData();
  }, [user]);

  const hasAccess = (moduleName) => {
    if (!accessData) return true;
    const mod = accessData.find(m => m.module_name === moduleName);
    return mod ? mod.data.some(r => r.access === "Y") : true;
  };

  const navigationLinks = hrLinks.map((link) => ({ ...link, access: hasAccess(link.name) }));
  return (
    <div style={{ width: "220px", minHeight: "100vh", backgroundColor: "#212529", color: "white" }}>
      <ul className="list-unstyled p-3 mt-3 mb-0">
        <h5 className="mx-2">HR System</h5>
        <hr className="m-1" />
        {navigationLinks.map((link) => {
          const access = link.access !== false;
          return (
            <li
              key={link.to}
              className={`p-2 d-flex align-items-center ${pathname === link.to ? "bg-light text-dark" : ""}`}
              style={{ opacity: access ? 1 : 0.5, pointerEvents: access ? "auto" : "none" }}
              title={access ? "" : "Access Denied"}
            >
              <Link
                to={access ? link.to : "#"}
                className="text-decoration-none d-flex align-items-center w-100"
                style={{ color: pathname === link.to ? "#000" : "#fff", fontSize: ".8rem", fontWeight: "200" }}
              >
                <span className="me-2" style={{ fontSize: ".9rem" }}>
                  {iconMap[link.name] || null}
                </span>
                {link.name}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default HrSidebar;
